import React from 'react';
import Joyride from 'react-joyride';
import MediaQuery from 'react-responsive';
import { setLocalStorage, lockPageScroll, unlockPageScroll } from '@zola-helpers/client';

import TourTooltip from '../../../common/ui/Tour/TourTooltip/TourTooltip';

const WalkthroughTour = ({ steps, localStorageKey, desktopOnly = false }) => {
  const disableTour = () => {
    setLocalStorage(localStorageKey, true);
  };

  const handleJoyrideCallback = data => {
    if (data.type === 'tour:end') {
      disableTour();
    }

    if (data.action === 'reset' && data.type === 'tour:status') {
      unlockPageScroll();
    } else {
      lockPageScroll();
    }
  };

  return (
    <MediaQuery minWidth={desktopOnly ? 992 : 768}>
      <Joyride
        steps={steps}
        callback={handleJoyrideCallback}
        showProgress
        continuous
        showSkipButton
        hideBackButton
        scrollToFirstStep
        scrollOffset={250}
        styles={{ options: { zIndex: 1000 } }}
        tooltipComponent={TourTooltip}
        className="hidden-xs hidden-sm"
        floaterProps={{ disableAnimation: true, hideArrow: true }}
      />
    </MediaQuery>
  );
};

export default WalkthroughTour;
